import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@material-ui/core';

export default function AssinaturaCallback(): JSX.Element {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const code = searchParams.get('code');
  const state = searchParams.get('state');
  const error = searchParams.get('error');
  const errorMsg = searchParams.get('error_msg');
  const [message, setMessage] = useState('Processando autorização Gov.br...');

  useEffect(() => {
    const isPopup = Boolean(window.opener && !window.opener.closed);

    if (error || errorMsg) {
      const errorMessage = errorMsg || `Erro na autorização: ${error}`;
      setMessage(errorMessage);
      if (isPopup) {
        window.opener?.postMessage(
          {
            type: 'ASSINATURA_GOVBR_ERROR',
            error: errorMessage,
          },
          window.location.origin,
        );
        window.setTimeout(() => window.close(), 800);
      }
      return;
    }

    if (code && isPopup) {
      setMessage('Autorização concluída. Fechando...');
      window.opener?.postMessage(
        {
          type: 'ASSINATURA_GOVBR_AUTORIZADO',
          code,
          state,
        },
        window.location.origin,
      );
      window.setTimeout(() => window.close(), 500);
      return;
    }

    if (code) {
      setMessage('Autorização concluída.');
    }
  }, [code, state, error, errorMsg]);

  return (
    <Box
      display='flex'
      flexDirection='column'
      alignItems='center'
      justifyContent='center'
      minHeight='100vh'
      p={3}
    >
      <CircularProgress size={40} style={{ marginBottom: 16 }} />
      <Typography variant='h6' gutterBottom>
        Assinatura Gov.br
      </Typography>
      <Typography variant='body2' color='textSecondary' align='center'>
        {message}
      </Typography>
    </Box>
  );
}
